/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { getGatewayUrl } from 'shared-ui/utils/getGatewayUrl';

// The active season/year prefix for the hero image assets (e.g. 'fall-26').
// Update this each rotation to point at the new set of images.
export const heroImageSeasonYear = 'fall-26';

// Hero Image Info
export const heroImages = [
    {
        heroBgImg: 'hero-01',
        locationName: 'Mount Rainier National Park, WA',
        locationLink: getGatewayUrl('2835'),
        photoCredit: 'Zachary Kunselman (Share the Experience)',
        altText:
            'A chipmunk sitting on a rock and holding a leafy plant at Mount Rainier National Park, WA',
    },
    {
        heroBgImg: 'hero-02',
        locationName: 'Cuyahoga Valley National Park, OH',
        locationLink: getGatewayUrl('2652'),
        photoCredit: 'Amelia Pecic (Share the Experience)',
        altText:
            'A forested hillside in fall color under a blue sky at Cuyahoga Valley National Park, OH',
    },
    {
        heroBgImg: 'hero-03',
        locationName: 'White Mountain National Forest, NH',
        locationLink: getGatewayUrl('1087'),
        photoCredit: 'Kathryn Whalen (Share the Experience)',
        altText:
            'A granite overlook above mountainsides in fall color at White Mountain National Forest, NH',
    },
    {
        heroBgImg: 'hero-04',
        locationName: 'Bosque del Apache National Wildlife Refuge, NM',
        locationLink: getGatewayUrl('1315'),
        photoCredit: 'Robert Roy (Share the Experience)',
        altText:
            'Sun shining through a golden cottonwood canopy at Bosque del Apache National Wildlife Refuge, NM',
    },
];

// Pick a random hero image for this page load.
export function getRandomHeroImage() {
    return heroImages[Math.floor(Math.random() * heroImages.length)];
}

export function HeroImage({ image }) {
    const { heroBgImg, altText } = image;
    const path = `${process.env.CDN}/img/homepage/hero-section/${heroImageSeasonYear}-${heroBgImg}`;

    return (
        <picture>
            <source media="(min-width: 1640px)" srcSet={`${path}-lg.webp`} />
            <source media="(min-width: 1240px)" srcSet={`${path}-md.webp`} />
            <source media="(min-width: 768px)" srcSet={`${path}-sm.webp`} />
            <img
                alt={altText}
                src={`${path}-xs.webp`}
                srcSet={`${path}-xs.webp 400w, ${path}-xs@2x.webp 800w, ${path}-xs@3x.webp 1200w`}
                sizes="100vw"
                {...{ fetchpriority: 'high' }}
            />
        </picture>
    );
}

HeroImage.propTypes = {
    image: PropTypes.shape({
        heroBgImg: PropTypes.string.isRequired,
        altText: PropTypes.string,
    }).isRequired,
};

// cSpell:ignore Kunselman, Pecic, Whalen, Cuyahoga
